"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Table = void 0;
var TableBox_1 = __importDefault(require("./TableBox"));
exports.Table = TableBox_1.default;
//# sourceMappingURL=index.js.map